(function(d, w, b) {
  var modal = d.querySelector('[data-questionnaire-modal]');
  if (!modal) return;

  var stages = d.querySelectorAll('[data-questionnaire-stage]');
  var stageIndicators = d.querySelectorAll('.progress-bar-indicator .questionnaire-stage-item');
  var titleStageNumber = d.querySelector('[data-questionnaire-count]');

  // Go between stages
  const swapStage = (stage, idx, alternate) => {
    stage.classList.remove('active-questionnaire');
    stageIndicators[idx].classList.remove('active-questionnaire');
    
    let index = idx + 1;
    if (alternate) {
      index = idx - 1;
      titleStageNumber.textContent = index + 1;
      stages[index].classList.add('active-questionnaire');
      stageIndicators[index].classList.add('active-questionnaire');
      modal.style.setProperty('--progress-bar-progress', stageIndicators[index].textContent + "%");
      
      return;
    }
    
    modal.style.setProperty('--progress-bar-progress', stageIndicators[index].textContent + "%");
    titleStageNumber.textContent = index + 1;
    stages[index].classList.add('active-questionnaire');
    stageIndicators[index].classList.add('active-questionnaire');
  }

  const lastStage = () => {
    modal.style.setProperty('--progress-bar-progress', "100%");
    stageIndicators[stageIndicators.length - 2].classList.remove('active-questionnaire');
    stageIndicators[stageIndicators.length - 1].classList.add('active-questionnaire');

    modal.classList.add("loading-questionnaire");
    // "Loading"
    setTimeout(() => {
      modal.classList.add('hide-questionnaire');
      modal.style.display = 'none';
      b.classList.remove('test-questionnaire-wrapper');
      b.dispatchEvent(new CustomEvent('reload:swipeable-area'));

      var pdpGrid = document.querySelector('productpage-grid');
      pdpGrid.reloadCalcs();
    }, 1500);
  }

  stages.forEach((stage, stageIndex) => {
    var radioButtons = stage.querySelectorAll('[data-questionnaire-answer]');
    var previousButton = stage.querySelector('[data-previous-question]');
    var nextButton = stage.querySelector('[data-next-question]');
    var finalButton = stage.querySelector('[data-final-question]');

    var activeRadio;

    // Allow only one active radio button
    radioButtons.forEach(btn => {
      var useElement = btn.querySelector('use');

      btn.addEventListener('click', () => {
        if (btn === activeRadio) return;

        if (nextButton && nextButton.hasAttribute('disabled')) {
          nextButton.removeAttribute('disabled');
        }

        if (finalButton && finalButton.hasAttribute('disabled')) {
          finalButton.removeAttribute('disabled');
        }

        if (activeRadio) {
          activeRadio.querySelector('use').setAttribute('href', '#icon-radio');
          activeRadio.classList.replace('radio-large-fill', 'radio-large');
        }
        
        useElement.setAttribute('href', '#icon-radio-active');
        btn.classList.replace('radio-large', 'radio-large-fill');

        activeRadio = btn;

        if (stageIndex === (stages.length - 1)) {
          lastStage();
          return;
        } 

        swapStage(stage, stageIndex);
      });

      if (nextButton) {
        nextButton.addEventListener('click', () => {
          swapStage(stage, stageIndex);
        });
      }

      if (previousButton) {
        previousButton.addEventListener('click', () => {
          swapStage(stage, stageIndex, true);
        });
      }

      if (finalButton) {
        finalButton.addEventListener('click', () => lastStage());
      }
    });
  });
  


})(document, window, document.body)